<template>
  <div>
    <!--  上传表格弹出框  -->
    <el-dialog
      :title="platFormTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      class="dialog"
      center
    >
      <div class="contents1">
        <el-form
          :model="platForm"
          :rules="rules"
          ref="platForm"
          label-width="auto"
        >
          <el-form-item label="上传文件" prop="url">
            <el-upload
              :action="`${BASE.PRO1}/versatile/region/bind/product/import`"
              :headers="{ token: token }"
              ref="upload"
              :data="{ id: id }"
              accept=".xlsx"
              :on-success="successFile"
              :on-error="errorFile"
              :before-remove="beforeRemove"
              :on-exceed="onExceed"
              :on-change="onChange"
              class="upload-demo"
              :multiple="false"
              :limit="1"
              :auto-upload="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-button size="small" type="primary" @click="downloadFile"
            >下载模版</el-button
          >
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFrom" :loading="submitLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import { postVersatileRegionBindProductImport } from "@/api/generalControl/zone";
import { postRegionBindProductFile } from "@/api/export/index.js";
import { BASE } from "@/api";
import { downLoadFlowBlob } from "@/utils/tools/base";

export default {
  props: ["id"],
  name: "uploadFile",
  data() {
    return {
      BASE,
      token: sessionStorage.getItem("token"),
      submitLoading: false,
      dialogFormVisible: false, //编辑弹窗
      platFormTitle: "", //弹框title
      platFormClone: {}, // 复制数据，用于初始化
      fileList: [],
      platForm: {
        url: "",
      },
      rules: {
        url: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
    };
  },
  created() {
    this.platFormClone = cloneDeep(this.platForm);
  },
  methods: {
    /**
     * 下载模版
     */
    async downloadFile() {
      try {
        const res = await postRegionBindProductFile();
        downLoadFlowBlob(res, res?.filename);
      } catch (error) {
        console.log(error, "postRegionBindProductFile");
      }
    },
    /**
     * 超出数量处理
     */
    onExceed() {
      this.$message.warning(`抱歉，最多只能上传1份文件`);
    },
    /**
     * 上传操作
     */
    successFile(e) {
      console.log(e, "e====");
      this.submitLoading = false;
      if (e.code == 20000) {
        // let skuCodes = e.data.failSkuCode.join(",");
        // let text = `总上传商品${e.data.count}个，正常添加${e.data.successCount}个，${e.data.failCount}个商品有异常添加；`;
        // let text1 =
        //   e.data.failSkuCode.length > 0 ? `异常商品货号:${skuCodes} ` : "";
        this.dialogFormVisible = false;
        this.tool.message(`上传成功`, "success");
        // this.tool.message(`${text}${text1}`, "success");
        this.$emit("submit-form"); // 刷新列表
      } else {
        this.tool.message(e.msg, "error");
      }
    },
    /**
     * 上传失败
     */
    errorFile(e) {
      this.platForm.url = "";
      this.$message({
        type: "error",
        message: "上传失败",
      });
    },
    /**
     * 删除文件
     */
    beforeRemove(file, fileList) {
      this.fileList = [];
      this.$refs.upload.clearFiles();
    },
    onChange(file) {
      console.log(file, this.fileList, "fileList==");
      // 可以在这里对文件进行一些验证
      this.fileList.push(file);
    },
    /**
     *新增
     */
    addData() {
      this.platFormTitle = "添加商品";
      this.platForm = {
        ...this.platFormClone,
      };
      this.dialogFormVisible = true;
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.upload.clearFiles();
        this.$refs.platForm.clearValidate();
      });
    },
    /**
     * 提交表单
     */
    submitFrom: debounce(function () {
      console.log(this.fileList, this.$refs.upload, "==");
      if (this.fileList.length == 0) {
        this.tool.message("请上传文件", "error");
        return;
      } else {
        this.submitLoading = true;
        this.$refs.upload.submit(); // 触发上传
      }
    }, 300),
  },
};
</script>
<style scoped lang="scss">
.contents1 {
  box-sizing: border-box;
  padding: 10px 26px 40px;

  .hide {
    /deep/ .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
